import React from "react";
import "./Footer.css";
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaEnvelope,
  FaPhoneAlt,
  FaMapMarkerAlt,
} from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="footer-container">
      <div className="footer-content">
        {/* Logo + description */}
        <div className="footer-section">
          <h3 className="footer-title">Alwaleed</h3>
          <p>
            Entreprise basée à Dakar, offrant des services fiables et professionnels.
            Nous plaçons la qualité, l’intégrité et la satisfaction client au cœur de nos engagements.
          </p>
        </div>

        {/* Contact officiel (extrait de la plaquette) */}
        <div className="footer-section">
          <h4 className="footer-title">Contact</h4>
          <p><FaMapMarkerAlt className="icon" /> Cité Onomo, Route de l’Aéroport – Dakar, Sénégal</p>
          <p><FaPhoneAlt className="icon" /> +221 77 638 17 33</p>
          <p><FaPhoneAlt className="icon" /> Fixe : +221 33 858 89 22</p>
          <p><FaPhoneAlt className="icon" /> Intl : +1 (504) 495-0270</p>
          <p><FaEnvelope className="icon" /> contact@alwaleed.sn</p>
          <p style={{marginTop:8, fontSize:'.95rem', color:'#ccc'}}>Site : www.alwaleed.sn</p>
        </div>

        {/* Réseaux */}
        <div className="footer-section">
          <h4 className="footer-title">Suivez-nous</h4>
          <div className="footer-socials">
            <a href="#" aria-label="Facebook"><FaFacebookF /></a>
            <a href="#" aria-label="Instagram"><FaInstagram /></a>
            <a href="#" aria-label="LinkedIn"><FaLinkedinIn /></a>
          </div>
        </div>
      </div>

      {/* Bas du footer : mentions légales */}
      <div className="footer-bottom">
        <p>
          © 2025 <strong>Alwaleed</strong> — NINEA : 011254331 / RC : SN.DKR.2024.B.21349
          / Adresse : Cité Onomo, Route de l’Aéroport, Dakar — Sénégal
          / Mail : contact@alwaleed.sn
        </p>
      </div>
    </footer>
  );
};

export default Footer;
